import React from "react";

const ArrowRightThin = props => (
  <svg viewBox="0 0 7 13" fill="none" {...props}>
    <path
      d="M.465.762L.273.953a.315.315 0 000 .465L5.605 6.75.273 12.11a.315.315 0 000 .464l.192.192a.315.315 0 00.465 0l5.77-5.77a.315.315 0 000-.465L.93.761a.315.315 0 00-.465 0z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowRightThin;
